// src/constants/socketEvents.ts
export enum SOCKET_EVENTS {
  NOTIFICATION_UNREAD = 'NOTIFICATION_UNREAD',
  STUDENT_COMPLETE_COURSE = 'STUDENT_COMPLETE_COURSE',
}
